import { Box, Skeleton } from "@luce/ui";

export function InvoiceDetailSkeleton() {
  return (
    <Box className="gap-spacing-lg flex flex-col">
      <Box className="gap-spacing-md flex flex-col">
        {Array.from({ length: 5 }).map((_, index) => (
          <Box key={index} className="flex flex-row items-center justify-between">
            <Skeleton className="h-4 w-28" />
            <Skeleton className="h-4 w-24" />
          </Box>
        ))}
      </Box>
      <Skeleton className="h-6 w-24" />
      <Skeleton className="h-16 w-full" />
      <Skeleton className="h-6 w-40" />
      <Skeleton className="h-24 w-full" />
    </Box>
  );
}
